import React from "react";
import {
  FormGroup,
  InputGroup,
  Callout,
  Switch,
  Intent,
  Button
} from "@blueprintjs/core";
import styles from "./BankAccount.module.scss";
import FormInfo from "../../../atoms/FormInfo/FormInfo";

function AddBankAccountForm({
  error,
  routing,
  setRouting,
  accountNumber,
  setAccountNumber,
  fullName,
  setFullName,
  isRequesting,
  addNewAccount,
  isBusiness,
  setIsBusiness,
  setAddAccount,
  resetForm
}) {
  return (
    <>
      {error && (
        <Callout
          icon="error"
          intent={Intent.DANGER}
          title="We couldn't save your settings."
        >
          {error.message}
        </Callout>
      )}
      <>
        <FormGroup label="Bank Account">
          <FormInfo>
            To cash out your earnings, add your bank account to Video Squirrel.
            Please double check your routing number and account number. You can
            update or remove your bank account from Video Squirrel at any time.
          </FormInfo>
        </FormGroup>
        <FormGroup label="Full Name">
          <InputGroup
            type="text"
            autoCapitalize="none"
            autoCorrect="false"
            value={fullName}
            placeholder="Enter Name"
            onChange={setFullName}
          />
        </FormGroup>
        <FormGroup label="Routing Number">
          <InputGroup
            type="text"
            autoCapitalize="none"
            autoCorrect="false"
            value={routing}
            pattern="[0-9]*"
            placeholder="Routing Number"
            onChange={setRouting}
          />
        </FormGroup>
        <FormGroup label="Account Number">
          <InputGroup
            type="text"
            autoCapitalize="none"
            autoCorrect="false"
            value={accountNumber}
            placeholder="Account Number"
            onChange={setAccountNumber}
          />
        </FormGroup>
        
        <div className={styles.businessInfo}>
          <Switch
            checked={isBusiness}
            onChange={() => setIsBusiness(!isBusiness)}
            label="This account belongs to a business"
            alignIndicator={"right"}
            large="true"
            intent={Intent.PRIMARY}
          />
          
          <div className={styles.footer}>
            <Button
              onClick={() => {
                addNewAccount();
              }}
              intent={Intent.PRIMARY}
              loading={isRequesting}
              disabled={isRequesting}
              text="Save"
              style={{ marginRight: "8px" }}
            />
            <Button
              onClick={() => {
                setAddAccount(false);
                resetForm();
              }}
              disabled={isRequesting}
              intent={Intent.DANGER}
              text="Cancel"
            />
          </div>
        </div>
      </>
    </>
  );
}

export default AddBankAccountForm;
